var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "rotate(-180 6 6)",
    fill: "#307CAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 9.62828L7.09156 6.31453C7.09156 6.10484 6.97035 6 6.72792 6L5.27338 6C5.03095 6 4.90974 6.10484 4.90974 6.31453L4.66732 9.62828C4.66732 9.74265 4.70772 9.82844 4.78853 9.88562C4.84913 9.96187 4.92994 10 5.03095 10L6.97035 10C7.07136 10 7.16227 9.96187 7.24308 9.88562C7.30368 9.82844 7.33398 9.74265 7.33398 9.62828Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 4.66699C5.6335 4.66699 5.32432 4.53173 5.07311 4.26119C4.80258 4.00999 4.66732 3.70081 4.66732 3.33366C4.66732 2.96651 4.80258 2.64767 5.07312 2.37714C5.32432 2.12593 5.6335 2.00033 6.00065 2.00033C6.3678 2.00033 6.68664 2.12593 6.95717 2.37714C7.20838 2.64767 7.33398 2.96651 7.33398 3.33366C7.33398 3.70081 7.20838 4.00999 6.95717 4.2612C6.68664 4.53173 6.3678 4.66699 6.00065 4.66699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.c6ca562d51f506cee21039b9c6e4ce4f.svg";
export { ForwardRef as ReactComponent };